import { Suspense, useState } from "react";
import { useEffect } from "react";
import PlayerLayout from "../../layout/playerlayout/PlayerLayout";
import OrganizerLayout from "../../layout/organizerLayout/OrganizerLayout";
import { Routes, Route, useParams } from "react-router-dom";
import Error404 from "../../../common/errors/404Error";
import Loader from "../../../common/cards/Loader";
import React from "react";
import AuthEvent from "./AuthEvent";
import EventAwards from "../Components/EventAssignedAwards/EventAwards";
import Announcements from "../../Player/Announcements";
import TopBar from "../Components/Home/TopBar";
import { EVENT, isLoading, load, setEVENT, unload } from "../../../Store/Features/EventSlice";
import { useDispatch, useSelector } from "react-redux";
import useVariables from "../../../common/hooks/useVariables";
import { GetSingleEvent } from "../../../Config/API/events";
import { GetPanelsOfOwner } from "../../../Config/API/panel";
import About from "../../Player/Event/About";
import RegisterTeams from "../../Player/Event/RegisterTeams/RegisterTeams";

const Home = React.lazy(() => import("../Components/Home"));
const Schedule = React.lazy(() => import("../Components/League"));
const KOBrackets = React.lazy(() => import("../Components/KO"));
const MultiplayerSchedule = React.lazy(() => import("../Components/multiplayermatches"));
const History = React.lazy(() => import("../Components/History"));

function EventLayoutWrapper() {
  const [current, setcurrent] = useState("");
  const [isOrg, setisOrg] = useState(""); //event organizer
  const [panelFound, setPanelFound] = useState(false);
  const [teamFound, setTeamFound] = useState(false);
  const { id } = useParams();
  const dispatch = useDispatch();
  const event = useSelector(EVENT);
  const loading = useSelector(isLoading);
  const { viewer } = useVariables();

  const fetchEventDetails = async () => {
    try {
      dispatch(load());
      const res = await GetSingleEvent({ eventId: id });
      const res2 = await GetPanelsOfOwner(viewer?.id);

      const data = await res.json();
      const data2 = await res2.json();

      // Check if this announcement is posted by user
      const foundPanel = data2.result?.some(
        (panelEntry) => panelEntry._id === data?.result?.panel?._id
      );
      setPanelFound(foundPanel);

      // Check if the current user is a register Team member
      const foundTeam = data?.result?.registerteams.some((teamEntry) =>
        teamEntry?.team?.members.some((member) => member.player === viewer.id)
      );
      setTeamFound(foundTeam);

      if (data?.type === "success") {
        dispatch(setEVENT(data?.result));
      }
      dispatch(unload());
    } catch (e) {
      dispatch(unload());
    }
  };

  useEffect(() => {
    fetchEventDetails();

    return () => {
      setisOrg(null);
    };
  }, [id]);
  useEffect(() => {
    let viewer = JSON.parse(localStorage.getItem("userDetails"))?.role;
    viewer = String(viewer).toLowerCase();
    setcurrent(viewer === "player" ? "player" : "organizer");

    return () => {
      setcurrent(null);
    };
  }, []);

  if (loading) {
    return <Loader fullpage loading={"white"} text={"Fetching event details..."} />;
  }
  return (
    <Suspense fallback={<Loader fullpage />}>
      <Routes>
        <Route element={<AuthEvent />}>
          <Route path="/" element={current === "player" ? <PlayerLayout /> : <OrganizerLayout />}>
            <Route path="/history" element={<History />} />
            <Route path="/multiplayermatches" element={<MultiplayerSchedule />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/knock-out-matches" element={<KOBrackets />} />
            <Route path="/event-awards" element={<EventAwards />} />
            <Route
              element={
                <TopBar
                  data={event}
                  eventId={id}
                  panelFound={panelFound}
                  teamFound={teamFound}
                  isOrg={isOrg}
                />
              }>
              <Route path="/" element={<Home event={event} id={id} />} />
              <Route path="timeline" element={<Home event={event} id={id} />} />

              <Route
                path="announcements"
                element={
                  <Announcements event={event} panelFound={panelFound} teamFound={teamFound} />
                }
              />
              <Route path="registerteams" element={<RegisterTeams event={event} />} />
              <Route path="about" element={<About event={event} />} />
            </Route>
            <Route path="*" element={<Error404 />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}

export default EventLayoutWrapper;
